import Vue from 'vue'
import _moment from 'moment'
// eslint-disable-next-line
import mdf from 'moment-duration-format'
import _ from 'lodash'
import brush from 'brush'
import formatters from 'oderon-commons/src/formatters'

Vue.filter('moment', function moment(dt, fmt='YYYY-MM-DD HH:mm:ss ZZ', ifBlank='-') {
  if (dt == null) return ifBlank
  return _moment(dt).format(fmt)
})

Vue.filter('number', function number(n, decPlaces=0) {
  if ( n == null ) return ''
  return n.toLocaleString({
    minimumFractionDigits: decPlaces,
    maximumFractionDigits: decPlaces
  })
})

Vue.filter('sDuration', function sDuration(seconds, fmt='HH:mm:ss') {
  if ( seconds == null ) return '-'

  if ( ! _.isNumber(seconds) ) {
    var s = seconds.startTimestamp,
        e = seconds.endTimestamp

    if ( s == null || e == null ) seconds = 0
    else seconds = _moment(e).diff(s, 'seconds')
  }

  var d = _moment.duration(seconds * 1000)
  if ( fmt === 'humanize' ) return d.humanize()
  return d.format(fmt, {trim: false})
})

Vue.filter('timeago', function timeago(date, fmt) {
  if ( date == null || date === 0 ) return "-"
  if ( fmt == null ) return _moment(date).fromNow()

  var seconds = _moment().diff(date, 's')
  return _moment.duration(seconds, 's').format(fmt, {trim:false})
})

Vue.filter('hex', function hex(n, prefix) {
  if ( n == null ) return '—'
  let result = brush.toHexString(n)
  if ( prefix != null ) result = prefix + result
  return result
})

Vue.filter('ifBlank', function ifBlank(str, def) {
  if ( str == null || str.trim().length < 1 ) return def
  return str
})

Vue.filter('prettyJson', function prettyJson(x, ifBlank) {
  if ( x == null || (_.isString(x) && x.trim().length < 1) ) {
    return ifBlank
  } else {
    return JSON.stringify(x, null, ' ')
  }
})

Vue.filter('brYesNo', function brYesNo(x) {
  return x ? 'Sim' : 'Não'
})

const _m = 60,
      _h = 60 * _m,
      _d = 24 * _h,
      _M = 30 * _d,
      _y = 12 * _M

Vue.filter('smallTimeago', function smallTimeago(dt) {
  if ( dt == null ) return ''

  let d = _moment().diff(dt, 's'),
      f = Math.floor

  if ( d < _m ) return d + 's'
  if ( d < _h ) return f(d/_m) + 'm'
  if ( d < _d ) return f(d/_h) + 'h'
  if ( d < _M ) return f(d/_d) + 'd'
  if ( d < _y ) return f(d/_M) + 'M'
  return f(d/_y) + 'A'
})

Vue.filter('brLongDateTime', function brLongDateTime(dt) {
  if ( dt == null ) return ''
  return formatters.brLongDateTime(dt)
})